<template>
  <div class="container">
    <div class="row">
      <div class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
        <div class="ui-block">
          <div class="top-header top-header-favorit pt-4">
            <div class="top-header-thumb">
              <img src="/img/header-group.svg" class="header-img" alt="Group header" />
              <div class="img-overlay"></div>
              <div class="top-header-author author-content group-icon">
                <div class="author-thumb d-flex group-avatar">
                  <img :src="getGroupImagePath(group)" alt="author" class="fit-contain" />
                </div>
                <div class="author-content group-header-content" data-cy="groupName">
                  <div class="group-name-content">
                    <span class="author-name group-name">{{
                      group.name
                    }}</span>
                    <md-icon
                    data-toggle="tooltip"
                    data-placement="right"
                    :data-original-title="privacyTooltip"
                    :data-html="true"
                    class="privacy-icon"
                    >{{ privacyIcon }}</md-icon
                  >
                  </div>
                  <span class="group-members">{{
                    getCurrentGroupMembers.length + " members"
                  }}</span>
                </div>
              </div>
            </div>
            <div class="profile-section">
              <div class="d-flex profile-buttons-container">
                <div class="col col-xl-8 m-auto col-lg-8  profile-buttons">
                <div class="" v-if="showAbout" >
                  <LeftSideBarGroup :group="getCurrentGroup" />
                </div>
                  <ul class="profile-menu">
                    <li>
                      <router-link
                        :class="{ 'highlight-menu': menuOption === 0 }"
                        :to="{ name: 'GroupsTimeLine' }"
                        data-cy="timelineBtn"
                      >
                        <span>Timeline</span>
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        :class="{ 'highlight-menu': menuOption === 1 }"
                        :to="{ name: 'GroupsItems' }"
                      >
                        <span>Items</span>
                      </router-link>
                    </li>
                    <li>
                      <router-link :to="{ name: 'GroupMessages' }" :class="{ 'highlight-menu': menuOption === 2 }"
                        data-cy="groupMessagesBtn">
                        <a>Posts</a>
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        :class="{ 'highlight-menu': menuOption === 3 }"
                        :to="{ name: 'GroupsMembership' }"
                        data-cy="groupMembersBtn"
                      >
                        <span>Members</span>
                      </router-link>
                    </li>
                  </ul>
                </div>
                <router-link  v-if="(getModerator.id === loggedUser.id)" 
                  class="settings-button" 
                  :to="{ name: 'GroupSettings' }" 
                  :class="{ 'highlight-menu': menuOption === 4 }"
                  data-cy="groupSettingsBtn">
                  <span class="material-icons-outlined">
                    settings
                  </span>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalNewJoinRequest @joinrequest="tryToJoinGroup" :request="requesting" :result="joinResponse"
      :buttonTitle="setButtonName" @resetButton="resetModal"/>
    <ModalLeaveGroup yesButtonName="YES" noButtonName="NO" />
  </div>
</template>

<script>
import GroupHelper from "@/mixins/GroupHelper";
import ModalLeaveGroup from "@/components/molecules/ModalLeaveGroup.vue";
import { mapGetters } from "vuex";
import ModalNewJoinRequest from "@/components/molecules/ModalNewJoinRequest";
import groupPrivacy from "@/enum/group-privacy";
import UserHelperVue from "../../mixins/UserHelper.vue";
import LeftSideBarGroup from "@/components/organisms/LeftSideBarGroup";

export default {
  name: "HeaderGroup",
  props: ["group", "isHidden", "joinBtnResend"],
  components: { ModalLeaveGroup, ModalNewJoinRequest, LeftSideBarGroup },
  mixins: [GroupHelper, UserHelperVue],
  data() {
    return {
      joinResponse: null,
      requesting: false,
      buttonTitle: "",
      showAbout: false,
    };
  },
  methods: {
    async tryToJoinGroup(e) {
      await this.fetchModerator({ group: { id: this.group.id } });
      this.requesting = true;
      const result = await this.newRequestToJoin({ group: this.group, msg: e });
      await this.sendUserGroupMessageForModerator(this.getModerator, this.loggedUser, e, this.group.id);
      this.requesting = false;
      if (result.result === "You are already a member of this group") {
        this.joinResponse =
          "You already have a request to join this group. Please, wait for the moderator acceptance.";
      } else {
        this.joinResponse = result.result;
      }
      this.buttonTitle = "Ok";
    },
    openModalLeaveGroup() {
      $("#leave-group").modal("show");
    },
    openModal() {
      if (this.group.privacy === groupPrivacy.PUBLIC) {
        this.joinGroup({ groupId: this.group.id, groupName: this.group.name });
      } else {
        $("#join-request").modal("show");
      }
    },
    closeModal() {
      this.$refs.modal.closeModal();
    },
    resetModal() {
      this.joinResponse = null;
      this.requesting = false;
    },
     handleResize() {
      this.showAbout = window.innerWidth < 1024;
    }
  },
  computed: {
    ...mapGetters({
      myGroups: "getMyGroups",
      moderatorId: "getModeratorID",
    }),
    isMember() {
      return !!(this.myGroups.find((group) => {
          return group.groupId === this.group.id;
        }));
    },
    isModerator() {
      return this.loggedUser.id === this.moderatorId;
    },
    setButtonName() {
      if (this.buttonTitle === "Ok") {
        return "Ok";
      }
      if (this.joinBtnResend) {
        return "Resend Request";
      } else {
        return "Send Message";
      }
    },
    menuOption() {
      if(this.$route.name === "GroupSettings"){
        return 4
      } else if (this.$route.name === "GroupsMembership") {
        return 3;
      } else if (this.$route.name === "GroupMessages") {
        return 2;
      } else if (this.$route.name == "GroupsItems") {
        return 1;
      } else {
        return 0;
      }
    },
    privacyIcon() {
      if (this.group.privacy === groupPrivacy.PRIVATE) {
        return "lock";
      } else if (this.group.privacy === groupPrivacy.PUBLIC) {
        return "public";
      }
      return "visibility_off";
    },
    privacyTooltip() {
      switch (this.group.privacy) {
        case groupPrivacy.PUBLIC:
          return "<span class='privacy-tooltip'>Public groups are visible in search results, and membership is open to any Swampum user.</span>";
        case groupPrivacy.PRIVATE:
          return "<span class='privacy-tooltip'>Private groups are visible in search results, but membership is controlled by the group’s moderator. </span>";
        case groupPrivacy.HIDDEN:
          return "<span class='privacy-tooltip'>Hidden groups are not visible in search results, and membership is limited to users who are invited to join by the group’s moderator(s).</span>";
        default:
          return "";
      }
    },
  },
  async mounted() {
    this.showAbout = window.innerWidth < 1024;
    window.addEventListener('resize', this.handleResize);
    $("[data-toggle='tooltip']").tooltip();
    this.getMyGroups();
  },
};
</script>

<style lang="scss" scoped>
.ui-block {
  background-color: unset;
  border: unset;
}

.spinner-border-sm {
  width: 20px;
  height: 20px;
}

.highlight-menu {
  border-bottom: solid #05919b 3px;
  color: #05919b !important;
}

.header-img {
  max-width: 1268px;
}
.control-block-button {
  bottom: 65px;
  top: unset;
}

.top-header-author .author-content {
    margin-left: 0 !important;
}

.profile-section {
  display: flex;
  flex-direction: column-reverse;
  padding: unset;
  margin: 24px 0 24px 240px;
  z-index: 5;
}

.profile-buttons-container {
  justify-content: space-between;
}

.profile-buttons-container::before {
  background-color: #939393;
  position: absolute;
  bottom: 4%;
  content: "";
  height: 1px;
  width: 100%;
  z-index: 0;
}
@media screen and (max-width: 1008px) {
  .profile-buttons-container::before {
    bottom: 0%;
  }
}

.profile-buttons {
  margin: 0 !important;
  padding: 0 !important;
  min-width: calc(100% - 24px);
}

.settings-button {
  z-index: 999;
  line-height: 0;
}

.settings-button .material-icons-outlined {
  color: gray !important
}

.settings-button.highlight-menu .material-icons-outlined  {
  color: #05919b !important;
}

.profile-menu {
  justify-content: flex-start;
}
.profile-menu li {
  margin-right: 40px;
}

.profile-menu li>div,
.profile-menu li a {
  color: unset;
  z-index: 999;
}

.profile-menu li a a {
  padding-bottom: 3px;
  z-index: 999;
}

.privacy-icon {
  margin-left: 8px;
  color: $white  !important;
}

.author-content {
  display: flex;
}

.group-name {
  font-size: 36px;
  margin: unset;
}
.group-members {
  font-size: 16px;
  margin-top: 10px;
}
.group-header-content {
  display: flex;
  flex-direction: column;
}
.group-name-content {
  display: flex;
  align-items: center;
}
.img-overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  right: 4.44%;
  top: 0;
  bottom: 56.25%;
  background: rgba(0, 0, 0, 0.62);
  border-radius: 3.69871px 3.69871px 0px 0px;
}

.group-avatar {
  width: 160px;
  height: 160px;
  border: unset;
}

.about-me{
  background-color: #fff;
  border-radius: 5px;
  min-width: 100%;
}

@media (max-width: 1200px) {
  .control-block-button {
    bottom: 40px;
  }

  .profile-buttons-container {
    margin: unset;
  }

  .group-avatar {
    width: 160px;
    height: 160px;
  }
  .top-header.top-header-favorit .top-header-author {
    bottom: -40px !important;
  }
}

@media (max-width: 1023px) {
  .container {
    padding: 0 !important;
    max-width: 100%;
  }

  .top-header.top-header-favorit .top-header-author {
    bottom: -26px !important;
  }
  .top-header.top-header-favorit .author-content {
    margin-top: -40px;
}
  .group-avatar {
    width: 88px;
    height: 88px;
  }
  .group-members {
    margin-bottom: -16px;
  }
  .group-name {
    font-size: 24px;
  }
  .author-thumb {
    margin-right: 15px !important;
  }

  .profile-section {
    margin: 40px 72px 20px;
  }
  .profile-buttons-container, .profile-buttons-container ul {
    width: 100%;
  }
}

@media (max-width: 801px) {
  .control-block-button {
    top: unset !important;
  }
}
@media (max-width: 720px) {
  .profile-section {
    margin: 40px 8px 20px;
  }
}

@media (max-width: 460px) {
  .group-icon {
    bottom: 0 !important ;
    top: auto !important;
  }
  .group-avatar {
    width: 74px !important;
    height: 74px !important;
  }
  .group-name {
    font-size: 24px;
  }
  .group-members {
    margin-top: 0px;
  }
  .profile-menu {
    flex-direction: unset !important;
    width: 85%
  }
  .profile-buttons-container::before {
    bottom: 5%;
  }
}

@media (max-width: 350px) {
  .control-block-button {
    right: 4px !important;
  }
}

</style>
